
import Api from "../../common/APi/api";
import { CONTENT_URL,MICRO_CONTENT_URL,MICRO_OVERMOLDING_URL  } from '../../common/APi/apiurl';
export const pageResponse = async(url:string)=>{
const response = await Api.get(url);

return response.data;

}